<template>
  <div>
    <div class="topbar" v-if="topbar">
      <div :class="{ 'container-fluid p-0': onGame, 'container': !onGame }">
        <ul class="list-inline m-0">
          <li class="list-inline-item" v-for="slug in games" v-bind:key="slug">
            <router-link :to="`/choose_game/${slug}`" :class="{ 'active': slug === gameSlug }" class="py-1 px-2 d-inline-block">{{ slug | cap }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg fixed-top navbar-light" :style="{ 'top': (topbar) ? '32px' : 0 }">
      <div :class="{ 'container-fluid p-0': onGame, 'container': !onGame }">
        <router-link class="navbar-brand mr-3" to="/"><span class="logo">{{ appName }}</span></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="$route.path !== '/'">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="showCreateGameModal">Play</a>
            </li>
            <template v-for="link in links">
              <li class="nav-item" :class="{ 'active': $route.path === link.url }" v-bind:key="link.url" v-if="!link.children || link.children.length === 0">
                <router-link class="nav-link" :to="`/${gameSlug}${link.url}`" v-if="link.url[0] === '/'" :class="{ 'font-weight-bolder': link.strong }"><span v-if="link.icon" :class="link.icon"></span> {{ link.title }} <span class="badge badge-warning" v-if="link.new">NEW</span></router-link>
                <a class="nav-link btn" :href="link.url" v-if="link.url[0] !== '/'" target="_blank" :class="{ 'font-weight-bolder': link.strong, 'bg-discord-dark text-light': link.discord }"><span class="font-weight-normal" v-if="link.icon" :class="link.icon"></span> {{ link.title }} <span v-if="link.new" class="badge badge-warning">NEW</span></a>
              </li>
              <li class="nav-item dropdown" v-if="link.children && link.children.length > 0" v-bind:key="link.url">
                <a class="nav-link dropdown-toggle" href="#" :id="link.title" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ link.title }}</a>
                <div class="dropdown-menu" :aria-labelledby="link.title">
                  <router-link class="dropdown-item" :to="child.url" v-for="child in link.children" v-bind:key="child.url">{{ child.title }}</router-link>
                </div>
              </li>
            </template>
          </ul>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li class="d-flex align-items-center mr-2">
              <a href="https://github.com/demircancelebi/tafl" target="_blank" class="btn btn-link">
                <span class="fab fa-github mr-1"></span><span>Check out source code</span>
              </a>
            </li>

            <!-- <FeedbackButton /> -->
            <li class="nav-item" :class="{ active: $route.path === l.url }" v-for="l in signedInLinks" v-bind:key="l.url">
              <router-link :to="l.url" class="nav-link">
                {{ l.title }} <span v-if="$route.path === l.url" class="sr-only">(current)</span>
              </router-link>
            </li>
            <li v-if="isLoggedIn && !isAnonymous" class="d-flex align-items-center">
              <div class="dropdown" v-if="getUserData && getUserData.username">
                <button class="btn btn-link dropdown-toggle p-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getUserData.username }}</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <router-link class="dropdown-item" :to="`/p/${getUserData.username}`">Profile</router-link>
                  <a class="dropdown-item" href="#" @click.stop.prevent="logout()">Log out</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FeedbackButton from '@/components/FeedbackButton.vue';

import config from '@/config';

export default {
  name: 'Navbar',
  props: ['gameSlug'],
  components: {
    // FeedbackButton,
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'isAnonymous', 'getCurrentUser', 'getDefaultUsername', 'getUserData']),
    onGame() {
      return this.$route.path.indexOf('/games') === 0;
    },
    signedInLinks() {
      if (this.isAnonymous || !this.isLoggedIn) {
        return this.signinLinks;
      }
      return [];
    },
  },
  created() {
    if (this.isAnonymous === null) {
      window.firebase.auth().signInAnonymously();
    }

    window.firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('setUser', user);
        if (!user.isAnonymous) {
          const db = window.firebase.firestore();

          const userDocRef = db.collection('users').doc(user.uid);
          userDocRef.onSnapshot((userDoc) => {
            this.$store.dispatch('setUserData', userDoc.data());
          });
        }
      }

      if (this.getCurrentUser && this.getCurrentUser.uid) {
        const { uid } = this.getCurrentUser;
        this.handlePresence(uid);
      }
    });
  },
  methods: {
    showCreateGameModal(obj) {
      this.$root.$emit('showCreateGameModal', obj);
    },
    goOffline(uid) {
      const userStatusDatabaseRef = window.firebase.database().ref(`/status/${uid}`);
      userStatusDatabaseRef.set(null);
    },
    handlePresence(uid) {
      const db = window.firebase.database();

      // since I can connect from multiple devices or browser tabs, we store each connection instance separately
      // any time that connectionsRef's value is null (i.e. has no children) I am offline
      const myConnectionsRef = db.ref(`/status/${uid}/connections`);

      // stores the timestamp of my last disconnect (the last time I was seen online)
      const lastOnlineRef = db.ref(`/status/${uid}/lastOnline`);

      const connectedRef = db.ref('.info/connected');
      connectedRef.on('value', (snap) => {
        if (snap.val() === true) {
          // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
          const con = myConnectionsRef.push();

          // When I disconnect, remove this device
          con.onDisconnect().remove();

          // Add this device to my connections list
          // this value could contain info about the device or a timestamp too
          con.set(true);

          // When I disconnect, update the last time I was seen online
          lastOnlineRef.onDisconnect().set(window.firebase.database.ServerValue.TIMESTAMP);
        }
      });

      db.ref('status').on('value', (doc) => {
        this.$store.dispatch('setPresence', doc.val());
      });
    },
    logout() {
      const { uid } = this.getCurrentUser;
      this.$store.dispatch('logout');
      this.goOffline(uid);
      window.firebase.auth().signInAnonymously();
    },
  },
  data() {
    return {
      appName: config.appName,
      games: config.games,
      topbar: config.topbar,
      sideNames: config.sideNames,
      types: config.types,
      links: [
        // {
        //   title: 'Play',
        //   url: '/#create-game',
        // },
        {
          title: 'Learn',
          url: '/learn',
          // children: [
          //   {
          //     title: 'Tafl basics',
          //     url: '/learn',
          //   },
          // ],
        },
        {
          title: 'Leaderboard',
          url: '/leaderboard',
        },
        {
          title: 'Join Discord Server',
          url: 'https://discord.gg/XmxVHV7',
          icon: 'fab fa-discord',
          strong: true,
          new: false,
          discord: true,
        },
        // {
        //   title: 'Community',
        //   url: 'https://community.litafl.com/',
        // },
      ],
      signinLinks: [
        {
          title: 'Sign up',
          url: '/signup',
        },
        {
          title: 'Log in',
          url: '/login',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.navbar {
  z-index: 1030;
  background: #fff;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
}
.navbar-brand {
  margin: 0;
  padding: 0;
}
.logo {
  font-weight: 900;
  letter-spacing: -1.2px;
  color: rgba(0,0,0,.9);
  font-size: 26px;
}
.navbar {
  top: 32px;
}
.topbar {
  background: #333;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1040;
  li > a {
    background: #333;
    color: #fff;
    &:hover {
      text-decoration: underline;
    }
    text-decoration: none;
    &.active {
      &:hover {
        text-decoration: none;
      }
      background: #fff;
      color: #333;
    }
  }
}
</style>
